<template>
  <div class="main">
    <slot />
  </div>
</template>
<script>
export default {
  mounted() {}
};
</script>
<style lang="scss">
@import "@/assets/style/css/generic-variables.scss";
@import "@/assets/style/css/App.scss";

.main {
  height: 100%;
  width: 100%;
}
</style>
